import {
  CreateWeightClassDto,
  WeightClassDto,
  WeightClassesApi,
  WeightClassesApiWeightClassesUpsertWeightClassSetsRequest,
  WeightClassSetResponseDto,
} from '@storage/app/api'

export class WeightClassService {
  constructor(private api: WeightClassesApi) {}

  async getAll(): Promise<Array<WeightClassDto>> {
    const { data: weightClasses } = await this.api.weightClassesGetAll()
    return weightClasses
  }

  async create(createWeightClassDto: Array<CreateWeightClassDto>): Promise<void> {
    await this.api.weightClassesCreate({
      createWeightClassDto,
    })
  }

  async getAllWeightClassSets(): Promise<Array<WeightClassSetResponseDto>> {
    const { data: weightClasses } = await this.api.weightClassesGetAllWeightClassSets()
    return weightClasses
  }

  async upsertWeightClassSets(cmd: WeightClassesApiWeightClassesUpsertWeightClassSetsRequest): Promise<void> {
    await this.api.weightClassesUpsertWeightClassSets(cmd)
  }
}
